//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import React, { useState, useCallback, useMemo, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, connect } from "react-redux";
import styled from "styled-components";
import moment from "moment";
import { Snackbar } from '@mui/material';

import { Alert } from '@mui/material';
import { find, flatMap, map, get, has, isPlainObject, isEmpty } from "lodash";
//  -- Components ---------------------
import { Button, Modal } from '@mui/material';
import { Check, WatchLater, ArrowRight , Close } from '@mui/icons-material';
// import MuiAccordion from '@material-ui/core/Accordion';
// import MuiAccordionDetails from '@material-ui/core/AccordionDetails';
// import MuiAccordionSummary from '@material-ui/core/AccordionSummary';
import { Accordion as MuiAccordion, AccordionSummary as MuiAccordionSummary, AccordionDetails as MuiAccordionDetails } from '@mui/material';
import { Typography } from '@mui/material';
//  -- Constants ----------------------
import COLOR from "utils/constants/color";

//  -- Lib ----------------------------
import { imageFetch, structureFetch, imageFetchFromPodcast, getExceptionStatus, getStatusByCode, isVideo , getStoryUrl , generateUrlForNonEbook, getEbookAssignmentDeepLinkUrl, getNonAssignableMaskId, getAssignmentNavigationUrl } from "utils/lib/ebookHelper";

//  -- Thunks -------------------------
import { handleCreatePastSubmission } from 'store/pastSubmission/thunks';
import { TootipWrapper } from "components/TooltipWrapper";
import GradeDisplay from 'components/GradeDisplay';
import RetakeModal from "components/RetakeModal";
import { BookSynoname } from 'utils/config/reference';
import { useResources } from "store/resources/selectors";
import { useOrgTimezone } from 'store/organizations/selectors';
import { useServertime } from 'store/servertime/selectors';
import { checkIsManualGradable, isAfterTime, isBeforTime, isGradedByTeacher } from "utils/methods/math"
import { useBookUnits } from 'store/booksUnits/selectors';
import { useStory } from "store/story/selectors";
import "moment-timezone"
import { useSocket } from "store/chat/selectors";

import { BACK_TO_BOOK } from 'utils/config/reference';
import { useExams } from "store/exams/selectors";
import { lighten } from "polished";
import { isDisabledForMe } from "utils/methods/validateData";
import { Tooltip } from "antd";
import * as Sentry from '@sentry/react';
import { handleListQuestionOfWorksheet } from "store/worksheet/thunks";
import SpinLoader from "./Loader/SpinLoader";
import { NoteMark } from "./UI";
import SentryWrap from 'components/Sentry';
import { useAlert } from "./UI/alertSakeBar/alertProvider";
import { useApExams } from "store/apexams/selectors";
import { modifyUrlParams } from "modules/assignments/helper";
import { getCoverForAssignment, isWaitingForAiGradingRestriction } from "utils/methods/functions";
import closeIconSvg from "../utils/assets/images/close-icon.svg";
import rightTickSvg from "../utils/assets/images/right-tick.svg";
import { useUserProfileConfig } from 'store/users/selectors';
import { usePageCover } from "./hooks/pageCover/pageCover";
import { useAssignmentCoverTitle } from "./hooks/pageCover/useAssignmentCoverTitle";


//  ----------------------------------------------------------------------------
//  Styles
//  ----------------------------------------------------------------------------
const Actions = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width:500px) {
    position: unset;
  }
`;

const Responce = styled.button`
  display: flex;
  flex-direction: column;
  right: 14px;
  bottom: 16px;
  border-radius: 15px;
  border-width: 0px;
  min-height: 32px;
  padding-left: 15px;
  padding-right: 15px;
  justify-content: center;
  color: ${COLOR.white};
  width: 150px;
  align-items: center;
  cursor: pointer;
  font-weight: 700;
  background: linear-gradient(270deg, #9958EE 0.06%, #505FFE 99.93%);
  @media (max-width: 767px) {
    padding-left: 5px;
    padding-right: 5px;
    width: 128px;
  }
`;
const CompleteText = styled.span`
  align-items: center;
  color: ${p => p.deactivate ? COLOR.redishpink : COLOR.green100};
  display: flex;
  flex-direction: row;
  font-size: 14px;
  font-weight: 600;
`;
const Container = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  max-width: 85%;
  @media (min-width: 768px) and (max-width: 960px) {
     max-width: 80%;
     width: 80%;
  }
  @media (max-width: 767px){
     max-width: 80%;
     width: 80%;
  }
`;

const Header = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  margin-bottom: 16px;
  word-break: break-all;
`;

const Image = styled.img`
  border: 1px solid ${COLOR.black800};
  width: 100%;
  height: auto;
`;

const ImageContiner = styled.button`
  background-color: transparent;
  border: none;
  cursor: zoom-in;
  flex: 1;
  max-width: 154px;
  outline: none;
  padding-right: 24px;
  margin-bottom: 22px;
  @media (max-width: 599px) {
    max-width: 85px;
    padding-right: 20px;
  }
`;

const ImageModal = styled.div`
  left: 50%;
  max-width: 544px;
  padding: 0px 24px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`;

const TextContainer = styled.div`
  justify-content: flex-end;
  position: relative
`;

const Text = styled.div`
  font-size: 12px;
  font-weight: 300;
  line-height: 20px;
`;

const Wrapper = styled.div`
  align-items: flex-start;
  display: flex;
  width: 100%;
  height: auto;
  padding: 26px;
  border-bottom: 1px solid #D3D3D3;
  position: relative;
`;

const OuterWrapper = styled.div`
`
const AccordianTitle = styled(Typography)`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    width:100%;
`
const Rotate = styled.div`
    align-items: center;
    display: flex;
    height: 16px;
    justify-content: center;
    margin-right: 4px;
    transform: ${p => p.open ? 'rotate(90deg)' : 'rotate(0deg)'};
    transition: all 300ms ease;
    width: 16px;
`;
const Notification = styled.div`
    background-color: ${p => p.bgColor ? p.bgColor : lighten(0.45, '#3D5F8F')};
    border: 1px dashed ${p => p.bgColor ? p.color : '#3D5F8F'};
    border-radius: 3px;
    color: ${p => p.color ? p.color : '#3D5F8F'};
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 24px;
    padding: 8px;
`;

// ✅ Accordion
const Accordion = styled(MuiAccordion)(({ theme }) => ({
  border: '1px solid white',
  boxShadow: 'none',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&::before': {
    display: 'none',
  },
  '&.Mui-expanded': {
    margin: 'auto',
  },
}));

// ✅ AccordionSummary
const AccordionSummary = styled(MuiAccordionSummary)(({ theme }) => ({
  backgroundColor: '#03989e',
  color: 'white',
  textTransform: 'capitalize',
  borderBottom: '1px solid white',
  marginBottom: -1,
  minHeight: 47,
  height: 47,
  '&.Mui-expanded': {
    minHeight: 47,
  },
  '& .MuiAccordionSummary-content.Mui-expanded': {
    margin: '8px 0',
  },
}));

// ✅ AccordionDetails
const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '2px',
  display: 'flex',
  flexDirection: 'column',
}));

  
const CurrentSubmission = {
  backgroundColor: '#9933ff'
}

const ImageStoryTitle = styled.div`
    position: absolute;
    top: 54.5%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    text-align: center;
    font-weight: bold;
    font-size: 24px;
    z-index: 1;
`;
//  ----------------------------------------------------------------------------
//  Component
//  ----------------------------------------------------------------------------
//
//  Interaction
//
//  -- Description
//  TODO
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...

const ParentAssignmentStatus = ({
  chapter,
  data,
  submission,
  booksAllList,
  currentUser,
  showResponce,
  book,
  onShowResponce,
  assignment
}) => {
  const showAlert = useAlert();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const servertime = useServertime()
  const timezone = useOrgTimezone()
  const story = useStory();
  const apExams = useApExams();
  const bookUnits = useBookUnits();
  const { socketConnection, reCreateSocket } = useSocket();

  // State declarations
  const [modalOpen, setModalState] = useState(false);
  const [isRetakeOpen, setisRetakeOpen] = useState(false);
  const [responsesModalOpen, setResponsesModalOpen] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const [questions, setQuestions] = useState([]);
  const [loadingQuestions, setloadingQuestions] = useState(false);
  const [openReviewDialog, setReviewDialog] = React.useState(false);

  // Effects
  useEffect(() => {
    if (responsesModalOpen && submission?.id) {
      setExpanded(submission.id);
    }
  }, [responsesModalOpen, submission]);

  useEffect(() => {
    if (responsesModalOpen) {
      setExpanded('current');
    }
  }, [responsesModalOpen]);

  useEffect(() => {
    if (responsesModalOpen) {
      const y = window.scrollY;
      document.body.style.position = 'fixed';
      document.body.style.top = `-${y}px`;
    } else {
      const y = -parseInt(document.body.style.top || '0');
      document.body.style.position = '';
      document.body.style.top = '';
      window.scrollTo(0, y);
    }
  }, [responsesModalOpen]);
  

  const pastSubmissions = useMemo(() => {
    if (!submission || !submission.pastSubmissions) return [];
    const returnedAtNumbers = Array.isArray(submission.returned_at)
      ? submission.returned_at.map(num => parseInt(num)-1)
      : [];
    const grouped = submission.pastSubmissions.reduce((acc, sub) => {
      const submissionNum = parseInt(sub.submissions);
      if (!acc[submissionNum]) {
        acc[submissionNum] = [];
      }
      acc[submissionNum].push(sub);
      return acc;
    }, {});

    const filtered = Object.values(grouped).flatMap((group) => {
      const hasNonEmptyAnswers = group.some(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
      if (hasNonEmptyAnswers && !returnedAtNumbers.includes(parseInt(group[0].submissions))) {
        return group.filter(sub => Array.isArray(sub.answers) && sub.answers.length > 0);
      }
      return group;
    });
    const sorted = filtered.sort((a, b) => parseInt(a.submissions) - parseInt(b.submissions));
    return sorted;
  }, [submission]);

  useEffect(() => {
    if ((!pastSubmissions || pastSubmissions.length === 0) && expanded !== 'current') {
      setExpanded('current');
    }
  }, [pastSubmissions]);

  const isAssignmentTakable = useCallback(() => {
    if (get(data, "lateDate") == "always") {
      return true;
    } 
    else if (get(data, "lateDate")) {
      if (isAfterTime(get(data, "lateDate"), servertime, timezone)) {
        return true;
      } else if (isAfterTime(get(data, "dueDate"), servertime, timezone)) {
        return true;
      }
    }else{
      if (isAfterTime(get(data, "dueDate"), servertime, timezone)) {
        return true;
      }
      return false;
    }
  }, [servertime, data]); 
  const resources = useResources()
  const ungraded = get(data, "ungraded", false)
  const grade_type = get(data,"grade_type");
  const isCompleteInComplete = grade_type === "complete_incomplete"
  const max_point = data?.max_point && !isNaN(data?.max_point) ? Number.parseInt(data.max_point, 10) : 100
  const isPointSystem =  grade_type === "points"
  const is_game = submission?.assignmentType === "game" || submission?.type === "game" || data?.type === "game" || false;
  const is_debate = submission?.assignmentType === "debate" || submission?.type === "debate" ;
  const is_worksheet = submission?.assignmentType === "worksheet" || submission?.type === "worksheet" ;
  const is_loteria = submission?.assignmentType === "bingo" || submission?.type === "bingo";
  const is_data_debate = data?.type === "debate" || false;
  const is_data_loteria = data?.type === "bingo" || false;
  const is_data_worksheet = data?.type === "worksheet" || false;
  const retakeAvailable = submission
    ? submission?.exceptionStatus ==3?true: parseInt(submission?.submissions, 10) < parseInt(data?.retakes, 10) + 1
    : true;
  const { isException, exceptionStatusText } = getExceptionStatus(submission,currentUser);
  const hasDuration = !isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0;
    const deactive_for_me =  useMemo(()=>isDisabledForMe(data,currentUser.id),[data,currentUser])
  const isActive = get(data, "active", true) && !deactive_for_me;;
  const deactivateStudent = data?.deactivated_student?.includes(currentUser?.id);
  const view_result = useMemo(() => {
    const result_visibility_on = data?.result_visibility_on;
    return result_visibility_on ? isBeforTime(result_visibility_on) : true
  }, [])
  const { isAiPermissionEnabled } = useUserProfileConfig();
  let numberMasked = "";
  let nonAssignAbleMaskId = "";
  const checkBookAssignableOrNotAssignable = booksAllList?.find(book=> Number(book.id) === Number(data.data?.bookId)) || {};

  // for story
  const storyBook = find(story, ["bookId", data?.data?.bookId]) || {};
  const isStoryBook  = Object.entries(storyBook)?.length > 0;
  
  // for AP Exams
  const isApExams = Boolean(find(apExams, k => find(k.exams, c => c.bookId == data?.data?.bookId)))

  // for exams
  const exams = useExams();
  const examBookIds = exams?.flatMap((entry) =>
      entry.exams.map((exam) => `${exam.bookId}`)
    );
  const isExamBook = examBookIds?.includes(data?.data?.bookId)
  const numberMaskForNonAssignable = checkBookAssignableOrNotAssignable?.isNotAssignable && !isExamBook && !isStoryBook && !isApExams;
  const fetchData = async (id) => {
    try {
      const has_q = questions.length>0
        setloadingQuestions(!has_q);
        const response = await dispatch(handleListQuestionOfWorksheet(id));
        if(Array.isArray(response)&&response.length>0){
            setQuestions(response);
        }else{
            setQuestions([]);
            showAlert("No questions found for this worksheet.", "warning");
        }
        
    } catch (error) {
        
    } finally{
        setloadingQuestions(false)
    }
   
  };
  useEffect(() => {
    if (is_worksheet && showResponce&&assignment&&assignment.game_id) {
        fetchData(assignment.game_id);
    }
  }, [showResponce, assignment, submission])
  const getNumberMask = useCallback((_page) => {
    let _book = find(booksAllList, { id: chapter })
    if (_book) {
      let numberMask = find(_book.pages, k => k.pageId == _page)
      if (numberMask) {
        if (numberMask.NumberMasked)
          return numberMask.NumberMasked
        else
          return _page;
      } else {
        return _page;
      }
    } else {
      return _page;
    }
  }, [chapter, booksAllList])


  if(numberMaskForNonAssignable){
    // for non-assignble book
    const maskId = getNonAssignableMaskId(bookUnits,data);
    nonAssignAbleMaskId = maskId;
} else{
    // for assignable book
    numberMasked = getNumberMask(data?.data ? data.data.page : data.page)
}


  if (data && data.lateDate == "null") {
    data.lateDate = null;
  }
  const generateUrl = (CHAPTER_ID, page, activity, quiz,is_graphic_organizer) => {
    const storyUrl = getStoryUrl(story, CHAPTER_ID, page, quiz, activity)
    const backToLabel = BACK_TO_BOOK[CHAPTER_ID]
    const BALCON_PAGES = get(find(bookUnits, ["bookId", CHAPTER_ID]), "pages", [])
    const bookitem = find(BALCON_PAGES, k => parseInt(k.start) <= page && parseInt(k.finish) >= page)
    const url = generateUrlForNonEbook(bookitem?.id, page, activity, quiz, backToLabel, null, CHAPTER_ID,is_graphic_organizer)
    if (url && backToLabel) {
        return url;
    }
    else if (storyUrl) {
        return storyUrl;
    } else {
        return null;
    }
}
const graphicOrganizationRedirect = (data) => {
  const url = getEbookAssignmentDeepLinkUrl(data);
  if (url) {
    navigate(url);
    return true;
  }
  return false;
};
  const reditrectToAssignment = () => {
    const chapter = get(data, "data.chapter", "")
    const assignmentId = get(data, "data.id")
    const typeId = get(data, "data.typeId", '')
    const is_graphic_organizer = get(data, "data.type") === "graphic_organizer" || get(data, "data.activity_type") === "graphic_organizer";
    const assignmentPage = get(data, "data.page", 0)
     const generatedUrl = generateUrl(chapter,assignmentPage,typeId.includes('activity') ? assignmentId : null,typeId.includes('quiz') ? assignmentId : null,is_graphic_organizer) 
     if(data?.assignfrom && data?.assignfrom?.urlPath){
      if(data?.assignfrom?.urlPath?.includes('/video')){
        navigate(`/video?id=${chapter}&quiz=${assignmentId}`);
        return;
      }
      const modifiedUrl = modifyUrlParams(data.assignfrom.urlPath, {
          activity: typeId === 'activity' ? assignmentId : null,
          quiz: typeId === 'quiz' ? assignmentId : null,
        });
        navigate(modifiedUrl);
        return;
    }
     if (isVideo(chapter,resources)) {
      navigate(getAssignmentNavigationUrl(`/video?id=${chapter}&quiz=${assignmentId}`, data));
    }
    else if (generatedUrl) {
      navigate(getAssignmentNavigationUrl(generatedUrl, data));
    }
     else {
      if(!graphicOrganizationRedirect(data)){
        navigate(`/ebook?chapter=${chapter}&page=${assignmentPage}&activity=${typeId.includes('activity') ? assignmentId : null}&quiz=${typeId.includes('quiz') ? assignmentId : null}`);
      }
    }
  }

  const invokSend = (data) => {
    let socket = socketConnection ?? '';
    if (socket) {
      try {
        if (socket.readyState == 3) {
          reCreateSocket()
          setTimeout(() => {
            socket.send(JSON.stringify(data))
          }, 2000)
        } else {
          socket.send(JSON.stringify(data))
        }
      } catch (error) {
        Sentry.captureException(`201 Error in invokSend: ${error}`);
        console.log(error, "error")
      }
    }
  }

  const onSubmit = async () => {
    if (!isActive || deactivateStudent) {
      return;
    }
    if (submission?.complete && !retakeAvailable) {
      return;
    } else if (submission?.complete && retakeAvailable) {
      await dispatch(handleCreatePastSubmission({  submissionId: submission?.id , is_missing: submission?.exceptionStatus ==3?true: false }))
      // await dispatch(
      //   handleUpdateSubmission(submission?.id, {
      //     ...submission,
      //     complete: false,
      //     retaking: true,
      //     answers: [],
      //     graded: false,
      //     feedback: "",
      //     audioFeedback: null,
      //     timmer: 0,
      //     ai_feedback:[]
      //   })
      // );
      reditrectToAssignment()
      // const notificationData = {
      //   classId: get(currentClass, 'id', ''),
      //   displayName: get(submission, 'assignment.displayName', ''),
      //   userId: get(currentUser, 'id', ''),
      //   modified: new Date(),
      //   data: {
      //     chapter: get(submission, 'assignment.chapter', ''),
      //     page: get(submission, 'assignment.page', ''),
      //     id: get(submission, 'assignment.id', ''),
      //   },
      //   message: `${get(currentUser, 'firstName', '')} ${get(currentUser, 'lastName', '')} Retake this Assignment`,
      //   createdBy: get(currentClass, 'teacherId', ''),
      //   type: 'update_activity',
      //   seen: true
      // }
      // sendNotifications(notificationData);
    } else {
      reditrectToAssignment()
    }
  };
  const handleClose = () => {
    setReviewDialog(false);
  };

  const getButtonText = useCallback(() => {
  
     if (isAssignmentTakable()) {
       if (submission?.complete && retakeAvailable) {
         return "Retake";
       } else if (submission) {
         return "Resume";
       } else if (isException) {
         return exceptionStatusText
       } else {
         return "Start"
       }
    } else {
       if (isException) {
         return exceptionStatusText
       }
       else if (submission?.complete && !submission.retaking) {
         return "completed"
       }
       return "Past due"
    }
  }, [servertime, submission])
  const getAssignmentName = () => {
    let displayName = data?.displayName ? data?.displayName : data?.data?.displayName
    let shortName = BookSynoname[chapter];
    let shortN = data?.typeId === "quiz" ? "Q" : "A";
    let pg = getNumberMask(data?.data?.page|| data?.assignment?.pageId || data?.pageId);
    pg = pg?.length > 20 ? data?.data?.bookId?.substring(0, 10) : `Pg.${pg ?? ""}`;
    return is_data_debate ? displayName: `${displayName} (${shortName ?? shortN}|${pg ||''})`
  }
  const AssignmentTitle = getAssignmentName();
  const pageCover = usePageCover({ assignmentData: data?.data });
  const getThumbnail = (zoom) => {
    const src = isVideo(get(data, "data.chapter"), resources) ? imageFetchFromPodcast(get(data, "data.page"), resources) : imageFetch(booksAllList, chapter, get(data, "data.page"))
    const cover_img_ext = getCoverForAssignment(data)
    const cover_img =  pageCover ? pageCover : cover_img_ext ? cover_img_ext : src
    return(
      <>
      <Image
      src={cover_img}
      alt=""
      />
      {/* {modalOpen && (
        <ImageStoryTitle>{data?.data?.displayName || ""}</ImageStoryTitle>
      )} */}
    </>
    )
  }
  const getResources = () => {
    const dataResource = find(flatMap(map(resources, k => k.videos)), { id: data?.data?.page })
    return dataResource.resource;
  }

  const getCompleteInclompleteMark = (isComplete)=>{
      if(isComplete){
        return <Check style={{ color: COLOR.green100, fontSize: 18 }} />
      } else{
        return <Close style={{ color: COLOR.red, fontSize: 18 }} />
      }
}

const getGrade = () => {
  if (!submission || !submission.id) return '-';
  if (submission.retaking && !submission.complete) {
      return "in progress";
  }
  const grade = submission?.grade >= 0 ? submission.grade : '';
  const bg_text = "TBG";
  const face_grade = submission?.face_grade;
  const isTbg = submission?.manualGrading && checkIsManualGradable((get(submission, "assignment.questions")));
  if(submission?.assignmentType === "bingo" && ungraded){
    const isSubmitted = submission?.answers?.length > 0 ? submission?.answers?.some((el)=> el?.is_submitted):false;
    return isSubmitted ? 'Credit' : '-';
  }
  if (ungraded) return 'Credit';
  if (isCompleteInComplete && (has(submission, "id") || !isAssignmentTakable())) {
      return getCompleteInclompleteMark(submission?.grade > 0);
  }
  if (isPointSystem) {
    if (isTbg) {
      return face_grade ? `${face_grade}/${max_point} (${bg_text})`:`${bg_text}/${max_point}`;
    }
    return face_grade > 0 || face_grade == 0
      ? `${face_grade}/${max_point}`
      : `0/${max_point}`;
  } else {
    if (isTbg) {
      return grade==0||grade>0?`${grade} (${bg_text})`: `${bg_text}`
    }
    return grade == 0 || grade > 0 ? grade : '-';
  }
};
  const handleChangeExpend = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : null);
  };
  const getGradePastSubmissions = (pt) => {
    const grade = pt?.grade>0||pt?.grade==0?pt?.grade:0;
    if(pt?.assignmentType === "bingo" && ungraded){
      const isSubmitted = pt?.answers?.length > 0 ? pt?.answers?.some((el)=> el?.is_submitted):false;
      return isSubmitted ? 'Credit' : '-';
    }
    if (ungraded) return 'Credit'
    if (isCompleteInComplete) {
      return grade > 0 ? 'Completed' : 'In completed';
    } else if (isPointSystem) {
      if (grade > 0 && max_point > 0) {
        return `${Math.round((grade / 100) * max_point)}/${max_point}`
      } else {
        return `0/${max_point}`;
      }

    }
    return `Grade -${grade}`;

  }

  const coverTitle = useAssignmentCoverTitle({
    assignment: { ...data, assignmentType: submission?.assignmentType, type: submission?.type }
  });
  const pastSubmissionView = useCallback(() => {
    if (pastSubmissions && pastSubmissions.length > 0) {
      return (
        <div>
          {map(pastSubmissions, pt => (
            <Accordion
              square
              expanded={expanded === pt.id}
              onChange={handleChangeExpend(pt.id)}
              className={`accordianTitleCstm ${expanded === pt.id ? 'active' : ''}`}
            >
              <AccordionSummary aria-controls="panel1d-content" id="panel1d-header">
                <AccordianTitle>
                  <span>{"Submission-" + pt.submissions} {getGradePastSubmissions(pt)} {isGradedByTeacher(pt,true)}</span> <Rotate open={expanded === pt.id}><ArrowRight /></Rotate>
                  <label className="accordiaAssigClos" onClick={() => setResponsesModalOpen(false)}>
                   <img src={closeIconSvg} alt="" />
                 </label>
                </AccordianTitle>
              </AccordionSummary>
              <AccordionDetails>
                <GradeDisplay
                  key={get(pt, "id")}
                  answers={get(pt, "answers")}
                  feedback={get(pt, "feedback")}
                  ai_feedback={get(pt, "ai_feedback")}
                  ai_suggestion={get(pt, "ai_suggestion")}
                  audioFeedback={get(pt, "audioFeedback")}
                  grade={get(pt, "grade")}
                  name={get(submission, "displayName", get(submission, "assignment.displayName"))}
                  questions={get(submission, "assignment.questions", [])}
                  type={"past due"}
                  isLate={pt.islate}
                  isExpended
                  assignment={pt}
                  hasFeedback={true &&(get(pt, "feedback")|| get(pt, "audioFeedback"))}
                  activity={data}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      );
    } else {
      return null;
    }
  }, [pastSubmissions, expanded]);

  const CurrentSubmissionView = useCallback(() => {
    if (get(submission, "submissions") != 0 || get(submission, "graded") || get(submission, "answers.length") > 0) {
      let PastSub = 0;
      map(pastSubmissions, pt => (
        PastSub = parseInt(pt.submissions)
      ));
      const LastSub = PastSub ? PastSub : 0;
      const CurrentSub = LastSub + 1;
      let Title = "";
      if (CurrentSub === 1) {
        Title = CurrentSub;
      } else {
        Title = CurrentSub + ' (Last Submission)';
      }
      const status = getGrade();
      const is_inprogress = status === 'in progress';
      return (
        <div className="accordiaAssignment">
          <Accordion
            square
            expanded={expanded === 'current'}
            onChange={handleChangeExpend('current')}
            className={`accordianTitleCstm ${expanded === 'current' ? 'active' : ''}`}
          >
            <AccordionSummary style={CurrentSubmission} aria-controls="panel1d-content" id="panel1d-header" className="assignAccordian">
              <AccordianTitle><span>{"Submission-" + Title}  {` Grade - ${get(submission, "exceptionStatus") > 0 ? getStatusByCode(get(submission, "exceptionStatus"),currentUser) : status}`} {isGradedByTeacher(submission)}</span> <Rotate open={expanded === 'current'}><ArrowRight /></Rotate> </AccordianTitle>
               <label className="accordiaAssigClos" onClick={() => setResponsesModalOpen(false)}>
                <img src={closeIconSvg} alt="" />
               </label>
            </AccordionSummary>
            <AccordionDetails>
              {is_inprogress ? <Notification>The assignment process is currently in progress.</Notification> : null}
              {currentUser?.role === "student" && is_inprogress ? null : (
                <GradeDisplay
                  key={get(submission, "id")}
                  answers={get(submission, "answers")}
                  feedback={get(submission, "feedback")}
                  ai_feedback={get(submission, "ai_feedback")}
                  ai_suggestion={get(submission, "ai_suggestion")}
                  audioFeedback={get(submission, "audioFeedback")}
                  grade={get(submission, "exceptionStatus") > 0 ? getStatusByCode(get(submission, "exceptionStatus"),currentUser) : getGrade()}
                  name={get(submission, "displayName", get(submission, "assignment.displayName"))}
                  questions={is_worksheet ? questions : get(submission, "assignment.questions", [])}
                  selected_student_id={submission?.userId}
                  type={"current due"}
                  is_game={is_game}
                  is_debate={is_data_debate || is_debate}
                  is_worksheet={is_data_worksheet || is_worksheet}
                  is_loteria={is_data_loteria || is_loteria}
                  isLate={get(submission, "isLate")}
                  isExpended
                  assignment={submission}
                  activity={data}
                />
              )}
            </AccordionDetails>
          </Accordion>
        </div>
      );
    }
  }, [pastSubmissions, expanded, questions]);

  if ((!data.data || !chapter || !Object.keys(data.data ?? {}).length > 0) && !is_data_debate && !is_data_loteria)
    return null;
  const isWaitingForAiGrading = () => {
    const is_waiting = isWaitingForAiGradingRestriction(submission,assignment ,isAiPermissionEnabled);
    if (is_waiting) {
      showAlert('Please wait while the AI processes your grading.', 'warning');
      return true;
    }
    //      if((Array.isArray(submission?.ai_grade) && submission?.ai_grade.length == 0)||( isPlainObject(submission?.ai_grade)&&isEmpty(submission?.ai_grade))){
    //   const is_waiting = submission.waiting_for_ai_grade
    //   if (is_waiting) {
    //     showAlert("Please wait while the AI processes your grading.", "warning");
    //     return true
    //   }
    // }
    return false;
  };
  const checkRetake = () => {
    if(isWaitingForAiGrading()) return;
    if (getButtonText() === "Retake") {
      setisRetakeOpen(true)
    } else {
      onSubmit()
    }
  }
  
  return (
    <SentryWrap>
    <OuterWrapper>
      <SpinLoader dataloader={loadingQuestions} />
      <Wrapper>
        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={openReviewDialog}
          autoHideDuration={3000}
          onClose={handleClose}>
          <Alert onClose={handleClose} severity="error">
            <strong>ALERT:</strong> Only for Review!
          </Alert>
        </Snackbar>
        <RetakeModal isRetakeOpen={isRetakeOpen} onClose={() => setisRetakeOpen(false)} onSubmit={onSubmit} />
        <Modal
          open={modalOpen}
          onClose={() => setModalState(false)}
          style={{ height: "100%", width: "100%" }}
        >
          <ImageModal>
            <div className="mdlBookTitleCstmUpr">  
              {getThumbnail(true)}
              {coverTitle ? <label className="mdlBookTitleCstm">{coverTitle}</label> : null}
            </div>  
          </ImageModal>
        </Modal>
        <ImageContiner onClick={() => setModalState(true)} className="semesterBookCvr">
          {getThumbnail()}
          {coverTitle ? <label className="semesterBookTitle">{coverTitle}</label> : null}
        </ImageContiner>
        <Container>     
          <Tooltip placement="bottom" title={AssignmentTitle}>
            <Header>
                {AssignmentTitle}
                {!isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0 && (
                  <WatchLater style={{ fontSize: "15px", marginLeft: "6px" }} />
                )}
            </Header>
          </Tooltip>
      
          <TextContainer>
            {!is_data_debate && (
              <>
                {isVideo(chapter, resources) ? (<Text>Resource: <strong style={{ color: COLOR.green300, fontWeight: 600 }}>{getResources()}</strong> </Text>
                ) : (<Text className="ebookInfo"><span>Book:</span><strong>{book?.description} </strong>{" "}</Text>)}
              </>
            )}
            {!is_data_debate && (
              <>
                {isVideo(chapter, resources) ? null : <Text className="ebookInfo"><span>Page:</span>
                  <strong>
                    {numberMaskForNonAssignable ? nonAssignAbleMaskId?.maskId : isStoryBook ? "story" : numberMasked}
                    {/* {getNumberMask(data?.data ? data.data.page : data.page)} */}
                  </strong>{" "}
                  {!data?.dueDate && (
                    <strong
                      style={{ marginLeft: "8px", textDecoration: "underline" }}
                    >
                      {structureFetch(booksAllList, chapter, data?.page)}
                    </strong>
                  )}
                </Text>}
              </>
            )}
            {data?.scheduleAt && (
              <Text className="ebookInfo">
                <span>Start Date:{" "}</span>
                <strong>
                  {moment(get(data, "scheduleAt")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            )}
            {/* {!is_data_debate && !is_data_loteria && data?.dueDate && (
              <Text className="ebookInfo">
                <span>Due Date:</span>
                <strong> */}
            {!is_game && !is_data_debate && !is_data_loteria && data?.dueDate && (
              <Text className="ebookInfo">
                <span>Due Date:</span>
                <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                  {moment(get(data, "dueDate")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            )}
            {!is_data_debate && data?.lateDate ? (
              <Text className="ebookInfo">
                <span>Late Submission:</span>
                <strong>
                  {get(data, "lateDate") == "always" ? "No limit" : moment(get(data, "lateDate")).format('MMM DD, YYYY hh:mm A')}
                </strong>
              </Text>
            ) : null}
            {!is_data_debate && data?.retakes && (
              <Text className="ebookInfo">
                <span>Retakes Allowed parent:</span>
                <strong>
                  {data?.retakes}
                </strong>
              </Text>
            )}
            {!is_data_debate && !isNaN(parseInt(data?.timeDuration)) && data?.timeDuration > 0 && (
              <Text className="ebookInfo">
                <span>Duration in minutes:</span>
                <strong>
                  {data?.timeDuration}
                </strong>
              </Text>
            )}
            {view_result ? <Text className="ebookInfo">
              <span>Grade:</span>
              <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                {ungraded && submission ? "Credit" : submission?.exceptionStatus > 0 ? getStatusByCode(submission?.exceptionStatus, currentUser) : getGrade()}
              </strong>
            </Text> : null}

             {!view_result?<NoteMark note={"Grade and feedback will be show upon the teacher approval"} />:null}
             
            {is_game ? <Text className="ebookInfo">
              Type:{" "}
              <strong style={{ color: COLOR.green300, fontWeight: 600 }}>
                Game
              </strong>
            </Text> : null}
            {is_data_debate || is_debate ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Debate
              </strong>
            </Text> : null}
            {is_data_worksheet || is_worksheet ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Grammar drill
              </strong>
            </Text> : null}
            {is_data_loteria ? <Text className="ebookInfo">
              <span>Type:</span>
              <strong>
                Loteria
              </strong>
            </Text> : null}
            {!data?.dueDate && (
              <Text className="ebookInfo">
                <span>Status:</span>{" "}<strong>Unassigned</strong>
              </Text>
          )}
          <div className="ebookStatus">
           {data?.dueDate && !is_data_loteria && (
            <Actions>
              <>
                {!get(submission, "complete") && !isAssignmentTakable() ? (
                  <CompleteText>Past Due</CompleteText>
                ) : (
                  <>
                    {get(submission, "complete") && (!retakeAvailable || (isBeforTime(get(data, "dueDate"), servertime, timezone) && isBeforTime(get(data, "lateDate", get(data, "dueDate")), servertime, timezone)))
                      ? (
                        <CompleteText className="ebookStatusSpan" deactivate={!isActive || deactivateStudent}>
                          {isActive ? <img src={rightTickSvg} alt="" /> : null}
                          {!isActive || deactivateStudent ? "Deactivated" : "Completed"}
                        </CompleteText>
                      ) : (
                        <TootipWrapper
                          hasToolTip={hasDuration || !isActive || deactivateStudent}
                          label={!isActive || deactivateStudent? "Assignment is deactivated by teacher" : submission ? `This activity includes a "timer", are you sure you want to resume it?` : null
                          }
                        >
                          <div className="rightComplete">
                          {/* <img src={rightTickSvg} alt="" /> */}
                          <Button
                            color={!isActive || deactivateStudent ? "secondary" : "primary"}
                            onClick={checkRetake}
                            disabled={!isAssignmentTakable() || currentUser?.role === 'parent'}
                            variant="contained"
                            style={{ marginBottom: "4px" }}
                          >
                            {!isActive || deactivateStudent ? "Deactivated" : getButtonText()}
                            {hasDuration && (
                              <WatchLater
                                style={{ fontSize: "15px", marginLeft: "6px" }}
                              />
                            )}
                          </Button>
                         </div> 
                        </TootipWrapper>
                      )}
                  </>
                )}
              </>
            </Actions>
          )}
          {data?.dueDate &&
            typeof submission == "object" &&
            Object.keys(submission).length > 0 && view_result && (
              <Responce onClick={() => { setResponsesModalOpen(true); onShowResponce(); }}>View responses</Responce>
            )}
          </div>  
          </TextContainer>
        </Container> 
      </Wrapper>

      {/* Start of Ebook Image Modal */}
        <Modal       
          open={modalOpen}
          onClose={() => setModalState(false)}
          style={{ height: "100%", width: "100%" }}>
          <ImageModal>
            <div className="mdlBookTitleCstmUpr">  
              {getThumbnail(true)}
              {coverTitle ? <label className="mdlBookTitleCstm">{coverTitle}</label> : null}
            </div>  
          </ImageModal>
        </Modal>
      {/* End of Ebook Image Modal */}

      {/* Start of Accordian Modal code */}
      {showResponce && (
        <Modal disableScrollLock={false} open={responsesModalOpen} onClose={() => setResponsesModalOpen(false)} className="accordianModal">
          <div className="ResponceContainerModal">
              {pastSubmissionView()}
              {CurrentSubmissionView()}
           </div>
        </Modal>
      )}
      {/* End of Accordian Modal code */}

    </OuterWrapper>
    </SentryWrap>
  );
};



const mapStateToProps = (state) => ({
  currentUser: state.currentUser,
});

export default connect(mapStateToProps, null)(ParentAssignmentStatus);
